/**
 * POPULATION-FORMATTER.TS
 * Format population object
 */
import { Session } from "@/redux/_session.types"
import { Population } from "./population.types"
import { PhysicalRisk } from "@/entities/physical-risk/model/physical-risk.types"
import { orderBy } from "lodash"
import { formatPhysicalRisksForPopulation } from "@/entities/physical-risk/model/physical-risk.formatter"
import { evaluateRps } from "./rps-evaluation"
import { PopulationContext } from "./population.store"

/**
 * Formatter function
 */
export function formatPopulation(population: Population, _session: Session, context: PopulationContext): Population {
  //Search risks, scored for this population
  const populationRisks = formatPhysicalRisksForPopulation(
    context.physicalRisks,
    context.physicalRiskContext,
    population.id
  )
  const cRiskMax: PhysicalRisk | null = orderBy(populationRisks, ["cValueEffective"], ["desc"])[0] ?? null

  return {
    ...population,
    cRiskMax,
    cColor: cRiskMax?.cValueEffectiveColor ?? "#cdcdcd",
    cRpsLevel: evaluateRps(population.optionsRps).level
  }
}
